export enum PaymentMethod {
  INVOICE = 'INVOICE',
  SEPA = 'SEPA'
}
